module.exports = __webpack_public_path__ + "Roboto-Regular.f9ae6d453f2fed6731d9.ttf";


//////////////////
// WEBPACK FOOTER
// /revet-web/src/assets/fonts/Roboto-Regular.ttf
// module id = ../../../../../src/assets/fonts/Roboto-Regular.ttf
// module chunks = styles